
<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button class="button no" (click)="onNoClick()">Ne</button>
  <button class="button yes" (click)="onYesClick()">Da</button>
</mat-dialog-actions>
